import Icons from "../../../assets/js/Icons";

export const menus = [
  {
    name: "dashboard",
    path: "/dashboard",
    icon: <Icons.DashboardSolid />,
  },
  {
    name: "FAQs",
    icon: <Icons.UserQuestionSolid />,
    menus: [
      {
        name: "add FAQ",
        path: "/faqs/add",
      },
      {
        path: "/faqs/all",
        name: "FAQs listing",
      },
    ]
  },
  {
    name: "Blogs",
    icon: <Icons.LicenseSolid />,
    menus: [
      {
        name: "Categories",
        path: "/blogs/categories",
      },
      {
        name: "add blog",
        path: "/blogs/add",
      },
      {
        path: "/blogs/all",
        name: "Blogs listing",
      },
    ]
  },
  {
    name: "Forums",
    icon: <Icons.LicenseSolid />,
    menus: [
      {
        name: "Categories",
        path: "/forum/categories",
      },
      {
        path: "/forum/all",
        name: "Forums listing",
      },
    ]
  },
  {
    name: "Specialists",
    icon: <Icons.LicenseSolid />,
    path: "/specialists/all",
  },
  {
    name: "Members",
    icon: <Icons.LicenseSolid />,
    path: "/members/all",
  },
  {
    name: "Appointments",
    icon: <Icons.LicenseSolid />,
    path: "/appointments/all",
  },
  {
    name: "Payments",
    icon: <Icons.LicenseSolid />,
    path: "/payments/all",
  },
  {
    name: "Wallet & Payouts",
    icon: <Icons.LicenseSolid />,
    menus: [
      {
        name: "Overview",
        path: "/wallet/overview",
      },
      {
        name: "Specialist Wallets",
        path: "/wallet/specialists",
      },
      {
        name: "Payout History",
        path: "/wallet/payouts",
      },
      {
        name: "Risk Center",
        path: "/wallet/risk",
      },
    ],
  },
  {
    name: "Webinars",
    icon: <Icons.LicenseSolid />,
    menus: [
      {
        name: "Webinars listing",
        path: "/webinar/all",
      },
    ]
  }
]